<header class="modal__header">
  <h3>{{ "transactions.label.filter" | translate }}</h3>
  <a class="button button--transparent modal__button--close" (click)="close()"><i class="icon icon-ui-close--sm"></i></a>
</header>

<div class="modal__content">
  <air-multi-select-search
    [id]="'multi-select-names'"
    [placeholder]="'transactions.label.filter_on_name' | translate"
    [items]="names"
    [(selectedItems)]="filters.names"
  ></air-multi-select-search>
  <air-multi-select-search
    [id]="'multi-select-dates'"
    [placeholder]="'transactions.label.filter_on_date' | translate"
    [items]="dates"
    [(selectedItems)]="filters.dates"
  ></air-multi-select-search>
</div>

<div class="modal__footer">
  <div class="button__group button__group--right">
    <a class="button button--secondary" (click)="close()">
      <span>{{ "general.label.cancel" | translate }}</span>
    </a>
    <a class="button button--primary" (click)="apply()">
      <span>{{ "product.filter.label.apply_filters" | translate }}</span>
    </a>
  </div>
</div>
<ng-template #noResults>
  <p>{{ "transactions.label.no_items_available" | translate }}</p>
</ng-template>
